module.exports = __webpack_public_path__ + "img/87.e3df4dcb.jpg";